// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomModal_wrapper__NIkna","wrapper__container":"CustomModal_wrapper__container__HS6PN"};